import HadithResultItem from './HadithResultItem';

export default HadithResultItem;
